import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatCard, MatCardContent } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";

/**
 * Shared wrapper card for notification-style UI elements (HITL cards, background job panel).
 * Provides the outlined mat-card with primary left-border accent, icon+title header row,
 * and named content slots for an optional badge and the body content.
 *
 * Usage:
 *   <app-notification-card iconName="help_outline" title="Confirmation Required">
 *     <span notifBadge class="notification-badge notification-badge--success">...</span>
 *     <!-- body content projected into default slot -->
 *   </app-notification-card>
 */
@Component({
  selector: "app-notification-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, MatIcon],
  templateUrl: "./notification-card.component.html",
  styleUrl: "./notification-card.component.scss",
})
export class NotificationCardComponent {
  readonly iconName = input.required<string>();

  readonly title = input.required<string>();

  /** compact=true uses tighter padding/gap; suitable for list-style panels. */
  readonly compact = input(false);

  protected readonly contentClass = computed(() =>
    this.compact() ? "d-flex flex-column gap-1 px-3 py-2" : "d-flex flex-column gap-3 p-3",
  );
}
